if (!customElements.get('hero-section')) {
  class HeroSection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.handleCTA();
    }

    handleCTA() {
      const ctaButton = this.querySelector('.hero-cta');
      if (!ctaButton) return;

      ctaButton.addEventListener('click', (e) => {
        const href = ctaButton.getAttribute('href');
        
        // Detectar si es un anchor (comienza con #)
        if (href && href.startsWith('#')) {
          e.preventDefault();
          const targetId = href.substring(1);
          const target = document.getElementById(targetId);
          
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
        // Si no es anchor, dejar que el navegador maneje el link normal
      });
    }
  }

  customElements.define('hero-section', HeroSection);
}
